import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUser,
  FaCogs,
  FaSignOutAlt,
  FaChartLine,
  FaStopwatch,
  FaShoppingBag,
  FaNewspaper,
  FaChalkboardTeacher,
  FaQuestionCircle,
  FaClipboardList  ,
  FaStore,
  FaMoneyBillWave
} from "react-icons/fa";
import { MdShoppingCartCheckout } from "react-icons/md";

import axios from "axios";
import LoadingSpinner from "../login/loading";

const Sidebar = ({ user, user_id, titre }) => {
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [groupeId, setGroupeId] = useState(null);
  const [isGroupeVerified, setIsGroupeVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(
    !sessionStorage.getItem("sidebarLoaded")
  );
  const location = useLocation();
  const navigate = useNavigate();
  const groupe = localStorage.getItem("groupe");
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [accesGroupe, setAccesGroupe] = useState([]); // State pour stocker les accès du groupe

  const toggleAdminMenu = () => {
    setIsAdminOpen(!isAdminOpen);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen); // Fonction pour ouvrir/fermer le sous-menu
  };

  const isActive = (path) => {
  if (path === "/papachigan") {
    return location.pathname === "/papachigan"; // Exact match pour l'accueil
  }
  return location.pathname.startsWith(path); // StartsWith pour les autres
};

  const activeStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "white",
    borderLeft: "4px solid rgb(248, 250, 251)", // Rouge clair pour contraster
  };

  const defaultStyle = {
    backgroundColor: "transparent",
    borderLeft: "none",
  };

  const navHeaderStyle = {
    marginBottom: "0",
    paddingTop: "0px",
    paddingBottom: "5px",
  };

  const sidebarStyle = {
    background: `
      linear-gradient(
        145deg,   
      #2f4050
      ),
      url('/texture-subtle.png')  /* Option: texture subtile */
    `,
    color: "white",
    textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)",
  };

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    emailConfirm: "",
    telephone: "",
    profession: "",
    diplome: "",
    formation: "",
    session: "",
    mdp: "",
    sexe: "",
    ajoute_par: "",
    statut: "",
  });

  //   const fetchParcours = async () => {
  //     try {
  //         const response = await fetch(
  //             `${process.env.REACT_APP_HOTE}/recuperer-etapes-par-utilisateur/${user_id}/`
  //         );

  //         if (response.ok) {
  //             const data = await response.json();

  //             // Récupérer la dernière donnée de fichiers_data
  //             const fichiersDataArray = Object.values(data.fichiers_data);
  //             const derniereDonnee = fichiersDataArray[fichiersDataArray.length - 1];

  //             // Extraire les étapes de la dernière donnée
  //             const etapes = derniereDonnee ? derniereDonnee.etapes || [] : [];

  //             console.log("Étapes :", etapes);

  //             // Vérifier si une étape "Eligibilite" existe
  //             const etapeEligibiliteExistante = etapes.some(etape => etape.module === "Eligibilite");

  //             // Chercher une étape "Eligibilite" qui respecte la condition sur l'étape précédente
  //             const eligibiliteEtape = etapes.find((etape, index) => {
  //                 if (etape.module === "Eligibilite") {
  //                     const etapePrecedente = index > 0 ? etapes[index - 1] : null;
  //                     return etapePrecedente ? etapePrecedente.statut_etape === "Terminée" : false;
  //                 }
  //                 return false;
  //             });

  //             // // Logique de mise à jour de l'état
  //             // if (eligibiliteEtape || !etapeEligibiliteExistante) {
  //             //     setEligibiliteExiste(true);
  //             // } else {
  //             //     setEligibiliteExiste(false);
  //             // }
  //         }
  //     } catch (error) {
  //         console.error("Erreur réseau:", error);
  //     }
  // };

  // Récupérer les informations de l'utilisateur

  const fetchUtilisateur = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`
      );
      const data = response.data;
      setFormData({
        nom: data.nom,
        prenom: data.prenom,
        email: data.email,
        emailConfirm: data.email,
        telephone: data.tel,
        profession: data.profession,
        diplome: data.diplome,
        formation: data.formation,
        session: data.session,
        mdp: data.mdp,
        sexe: data.sexe,
        ajoute_par: data.ajoute_par,
        statut: data.statut,
      });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données utilisateur",
        error
      );
    }
  };

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupe(JSON.parse(accesGroupeStored));
      setIsGroupeVerified(true);
      setIsLoading(false); // Les données sont chargées
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                    .replace(/[\[\]']/g, "")
                    .trim()
                    .split(",")
                    .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupe(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
          setIsGroupeVerified(true);
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
      setIsLoading(false);
      sessionStorage.setItem("sidebarLoaded", "true");
    }
  };

  const verifGroupeDeLutilisateur = async () => {
    const groupeStored = localStorage.getItem("groupe");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOTE}/groupe-de-l-utilisateur/${user_id}/`
      );
      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem("groupe", data.group_ids);
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du groupe", error);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchUtilisateur();
      verifGroupe();
      verifGroupeDeLutilisateur();
    }
  }, [user_id]);

  const handleLogout = () => {
    // Supprime tout dans localStorage et sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem("IDDDD");
    localStorage.removeItem("groupe"); 
    localStorage.removeItem("accesGroupe");
    localStorage.removeItem("access_token");
    localStorage.removeItem("redirectAfterLogin");
    localStorage.removeItem("sidebarLoaded");

    // Redirection vers la page d'accueil avec rechargement complet
    window.location.replace("/");
  };

  // const lancerQuiz = async () => {
  //   try {

  //     const response = await fetch(`${process.env.REACT_APP_HOTE}/lancer-quiz/?user_id=${user_id}`, {
  //       method: 'GET',
  //       headers: { 'Content-Type': 'application/json' },
  //     });

  //     if (response.ok) {
  //       const data = await response.json();

  //       // Naviguer après le succès
  //       navigate('/Quizz-demarrer', { state: { quizData: data } });
  //     }
  //   } catch (error) {
  //     // console.error('Erreur réseau:', error);
  //   }
  // };

  // Affiche un spinner tant que les données ne sont pas prêtes
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <nav
      className="navbar-default navbar-static-side"
      role="navigation"
      style={sidebarStyle}
    >
      <div className="sidebar-collapse">
        <ul className="nav metismenu" id="side-menu">
          <li
            className="nav-header"
            style={{
              ...navHeaderStyle,
             
              padding: "5px 25px",
              marginBottom: "10px",
            }}
          >
            <div className="dropdown profile-element">
              <div
                className="dropdown-toggle"
                onClick={toggleProfileMenu}
                style={{ cursor: "pointer" }}
              >
                <span className="font-bold text-white">
                  <h2>PayMe</h2>
                </span>
              </div>
            </div>
          </li>

          

          {/* Afficher "Produit" pour les utilisateurs */}
          
              <li style={isActive("/papachigan") || isActive("/Detail-produit") ? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/papachigan`,
                    state: { user },
                  }}
                >
                  <FaHome />{" "}
                  <span className="nav-label ml-2">Accueil</span>
                </Link>
              </li>

              <li style={isActive("/mes-achats") ? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/mes-achats`,
                    state: { user },
                  }}
                >
                  <FaClipboardList/>{" "}
                  <span className="nav-label ml-2">Mes achats</span>
                </Link>
              </li>
            
          
            
              <li style={isActive("/boutique") || isActive("/suivi-vente") || isActive("/remboursements") || isActive("/mes-produits")? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/boutique`,
                    state: { user },
                  }}
                >
                  <FaStore />{" "}
                  <span className="nav-label ml-2">Ma boutique</span>
                </Link>
              </li>

              
              <li style={isActive("/liste-remboursements") ? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/liste-remboursements`,
                    state: { user },
                  }}
                >
                  <FaMoneyBillWave   />{" "}
                  <span className="nav-label ml-2">Remboursements</span>
                </Link>
              </li>
        

          {/* Lien vers l'administration */}
          {accesGroupe.includes("Administration") && (
            <li
              style={
                isActive("/admin") ||
                  isActive("/Liste-groupe") ||
                  isActive("/Liste-utilisateur") ||
                  isActive("/Liste-produit") ||
                  isActive("/Liste-categorie") ||
                  isActive("/Liste-formation") ||
                  isActive("/Liste-diffusion") ||
                  isActive("/Liste-notification") ||
                  isActive("/Modifier-produit") ||
                  isActive("/Modifier-categorie") ||
                  isActive("/Modifier-groupe") ||
                  isActive("/Modifier-formation") ||
                  isActive("/Modifier-diffusion") ||
                  isActive("/Ajouter-groupe") ||
                  isActive("/Ajouter-produit") ||
                  isActive("/Ajouter-categorie") ||
                  isActive("/Ajouter-formation") ||
                  isActive("/Ajouter-diffusion") ||
                  isActive("/ajouter-utilisateur-diffusion") ||
                  isActive("/Configurer-groupe") ||
                  isActive("/Historique-admin") ||
                  isActive("/transaction") ||
                  isActive("/ajouter-utilisateur-groupe")
                  ? activeStyle
                  : defaultStyle
              }
            >
              <Link
                className="text-white"
                to={{
                  pathname: `/admin`,
                  state: { user },
                }}
              >
                <FaCogs />{" "}
                <span className="nav-label ml-2">Administration</span>
              </Link>
            </li>
          )}

          <li
            style={isActive("/profil-utilisateur") ? activeStyle : defaultStyle}
          >
            <Link
              className="text-white"
              to={{
                pathname: `/profil-utilisateur`,
                state: { user, titre },
              }}
            >
              <FaUser /> <span className="nav-label ml-2">Mon Profil</span>
            </Link>
          </li>

          <li className="ml-2" style={defaultStyle}>
            <Link
              onClick={handleLogout}
              style={{
                background: "none",
                border: "none",
                color: "white",
                cursor: "pointer",
                width: "100%",
                textAlign: "left",
                padding: "10px 15px",
              }}
            >
              <FaSignOutAlt />{" "}
              <span className="nav-label ml-2">Déconnexion</span>
            </Link>
          </li>

          {/* Reste du code pour les éléments de la sidebar */}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;
